import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { toast } from "react-toastify";
import Productsizechart from "../components/Productsizechart";
import { BASE_URL, getApiUrl } from "../utils/api";

const ProductDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [openLightbox, setOpenLightbox] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const [bulkCombos, setBulkCombos] = useState([]);
  const [bulkApplied, setBulkApplied] = useState(false);
  const [bulkFinalPrice, setBulkFinalPrice] = useState(0);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await fetch(getApiUrl("product-by-slug"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ slug }),
        });

        const data = await res.json();

        if (data.success) {
          setProduct(data.data);
          if (data.success) {
            setProduct(data.data);
            fetchBulkOffers(data.data.subcategoryId);

            const sizes = data.data.sizes || {};
            const firstAvailable = Object.keys(sizes).find((s) => sizes[s] > 0);

            if (firstAvailable) {
              setSelectedItems([
                { size: firstAvailable, qty: 1, price: data.data.price },
              ]);
            }
          }

          fetchBulkOffers(data.data.subcategoryId);
        }
      } catch (err) {
        console.error("Product fetch failed", err);
      }
    };

    if (slug) fetchProduct();
  }, [slug]);

  const fetchBulkOffers = async (subcategoryId) => {
    try {
      const res = await fetch(getApiUrl("bulk-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const data = await res.json();
      if (!data.success) return;

      const filtered = data.data.filter(
        (b) =>
          (b.subcategoryId?._id || b.subcategoryId)?.toString() ===
          subcategoryId?.toString(),
      );

      setBulkCombos(filtered);
    } catch (err) {
      console.error("Bulk combo fetch failed", err);
    }
  };

  const normalTotal = selectedItems.reduce((s, i) => s + i.qty * i.price, 0);

  useEffect(() => {
    if (selectedItems.length === 0 || bulkCombos.length === 0) {
      setBulkApplied(false);
      setBulkFinalPrice(0);
      return;
    }

    const totalQty = selectedItems.reduce((s, i) => s + i.qty, 0);
    const combo = bulkCombos[0];

    const slab = combo.priceSlabs.find(
      (s) =>
        totalQty >= s.minQuantity &&
        (!s.maxQuantity || totalQty <= s.maxQuantity),
    );

    if (!slab) {
      setBulkApplied(false);
      setBulkFinalPrice(0);
      return;
    }

    setBulkFinalPrice(slab.price);
    setBulkApplied(true);
  }, [selectedItems, bulkCombos]);

  const finalTotal = bulkApplied ? bulkFinalPrice : normalTotal;

  if (!product) return <p className="text-center mt-5">Loading…</p>;

  const images = [
    { src: `${BASE_URL}${product.mainImage}` },
    ...(product.extraImages || []).map((img) => ({
      src: `${BASE_URL}${img}`,
    })),
  ];

 

  const handleSelectSize = (size) => {
    const qtyAvailable = product.sizes[size];
    if (qtyAvailable === 0) return;

    
    if (selectedItems.some((s) => s.size === size)) {
      setSelectedItems(selectedItems.filter((s) => s.size !== size));
    } else {
      setSelectedItems([
        ...selectedItems,
        { size, qty: 1, price: product.price },
      ]);
    }
  };

  const updateQty = (size, value) => {
    const stock = product.sizes[size];

    setSelectedItems((prev) =>
      prev.map((i) =>
        i.size === size
          ? { ...i, qty: Math.min(stock, Math.max(1, Number(value))) }
          : i,
      ),
    );
  };

  const outOfStock = selectedItems.some((i) => i.qty > product.sizes[i.size]);

  const removeItem = (size) =>
    setSelectedItems(selectedItems.filter((i) => i.size !== size));

  const getGuestId = () => {
    let userId = localStorage.getItem("userId");
    if (!userId) {
      userId = "guest_" + Date.now();
      localStorage.setItem("userId", userId);
    }
    return userId;
  };

  const handleAddToCart = async () => {
    if (selectedItems.length !== 1) {
      alert("Please choose exactly ONE size to add to cart.");
      return;
    }

    const item = selectedItems[0];
    const userId = getGuestId();

    try {
      const res = await fetch(getApiUrl("cart-add"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          productId: product._id,
          quantity: item.qty,
          selectedSize: item.size,
        }),
      });

      const data = await res.json();

      if (data.success) {
        toast.success("Added to cart successfully 👍");
      } else {
        toast.error(data.message || "Failed to add to cart");
      }
    } catch (err) {
      alert("Server error");
    }
  };

  const proceedCheckout = () => {
    if (selectedItems.length === 0) {
      alert("Please choose at least one size.");
      return;
    }

    navigate("/bsk-checkout", {
      state: {
        products: selectedItems.map((item) => ({
          productId: product._id,
          name: product.productName,
          price: product.price,
          size: item.size,
          qty: item.qty,
          subtotal: item.qty * item.price,
        })),
        totalPrice: normalTotal,
        finalPrice: finalTotal,
      },
    });
  };
  const handleAddWishlist = async () => {
    try {
      let userId = localStorage.getItem("userId");
      if (!userId) {
        userId = "guest_" + Date.now();
        localStorage.setItem("userId", userId);
      }

      const res = await fetch(getApiUrl("wishlist-add"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          productId: product._id,
        }),
      });

      const data = await res.json();

      if (data.success && data.message === "Already in wishlist") {
        toast.info("Already in wishlist 💙");
      } else if (data.success) {
        toast.success("Added to Wishlist ❤️");
      } else {
        toast.error(data.message || "Failed");
      }
    } catch (err) {
      toast.error("Something went wrong ❗");
    }
  };
  const simpleShare = async () => {
    if (!product) return;

    const shareData = {
      title: product.productName,
      text: `🛍️ BSK Boutique\n₹${product.price}\nCheck this out!`,
      url: window.location.href,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log("User cancelled share");
      }
    } else {
      // Desktop fallback
      window.open(
        `https://wa.me/?text=${encodeURIComponent(
          shareData.text + " " + shareData.url,
        )}`,
        "_blank",
      );
    }
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-lg-6">
          <img
            src={images[0].src}
            alt={product.productName}
            className="w-100 rounded shadow"
            style={{ cursor: "zoom-in" }}
            onClick={() => setOpenLightbox(true)}
          />
        </div>

        <div className="col-lg-6">
          <div className="d-flex justify-content-between align-items-start gap-2 py-2">
            <h2 className="capitalize-text m-0 flex-grow-1">
              {product.productName}
            </h2>

            <div className="d-flex flex-column gap-2 flex-shrink-0">
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={handleAddWishlist}
              >
                <i className="fa-regular fa-heart"></i>
              </button>

              <button
                className="btn btn-outline-success btn-sm"
                onClick={simpleShare}
              >
                <i className="fa-solid fa-share-nodes"></i>
              </button>
            </div>
          </div>

          <h4 className="d-flex align-items-center gap-2">
            <span className="fw-bold text-success fs-3">₹{product.price}</span>

            <span className="text-muted text-decoration-line-through fs-6">
              ₹{product.originalPrice}
            </span>

            {product.originalPrice > product.price && (
              <span className="badge bg-warning text-dark ms-1">
                {Math.round(
                  ((product.originalPrice - product.price) /
                    product.originalPrice) *
                    100,
                )}
                % OFF
              </span>
            )}
          </h4>

          <label className="fw-bold">Click to Purchase</label>

          <div className="d-flex gap-2 flex-wrap mt-2">
            {Object.keys(product.sizes || {})
              .filter((size) => product.sizes[size] > 0)
              .map((size) => {
                const qtyAvailable = product.sizes[size];
                const isActive = selectedItems.some((s) => s.size === size);

                return (
                  <button
                    key={size}
                    className={`btn ${isActive ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => handleSelectSize(size)}
                  >
                    {size} — Stock: {qtyAvailable}
                    {isActive && " ✓"}
                  </button>
                );
              })}
          </div>

          {selectedItems.length > 0 && (
            <div className="card mt-4 shadow-sm">
              <div className="card-body">
                <h5>Order Summary</h5>

                {selectedItems.map((item) => (
                  <div
                    key={item.size}
                    className="d-flex justify-content-between align-items-center border-bottom py-2"
                  >
                    <div>
                      <strong>Size:</strong> {item.size}
                      <br />
                      <small>₹{item.price} each</small>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <div className="d-flex align-items-center gap-2">
                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => updateQty(item.size, item.qty - 1)}
                          disabled={item.qty === 1}
                        >
                          −
                        </button>

                        <span className="px-3">{item.qty}</span>

                        <button
                          className="btn btn-outline-secondary"
                          onClick={() => updateQty(item.size, item.qty + 1)}
                          disabled={item.qty >= product.sizes[item.size]}
                        >
                          +
                        </button>
                      </div>

                      <strong>₹{item.qty * item.price}</strong>

                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => removeItem(item.size)}
                      >
                        X
                      </button>
                    </div>
                  </div>
                ))}

                {outOfStock && (
                  <p className="text-danger mt-2">
                    ⚠ One or more items exceed available stock.
                  </p>
                )}

                {bulkApplied && (
                  <p className="text-success mt-2">
                    🎉 Bulk offer applied — special pricing activated!
                  </p>
                )}

                <div className="d-flex justify-content-between mt-3">
                  <h5>Total</h5>
                  <h5>₹{finalTotal}</h5>
                </div>

                <button
                  className="btn btn-primary mt-3 w-100"
                  disabled={outOfStock}
                  onClick={handleAddToCart}
                >
                  Add to Cart
                </button>

                <button
                  className="btn btn-success mt-2 w-100"
                  disabled={outOfStock}
                  onClick={proceedCheckout}
                >
                  Proceed to Checkout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="p-4">
        {product.sizeChartId && (
          <Productsizechart sizeChartId={product.sizeChartId} />
        )}

        {product.description && (
          <div className="mt-4">
            <h5 className="fw-bold mb-3">Product Details</h5>

            <div className="description-list">
              {product.description
                .split(/\r?\n/)
                .filter((line) => line.trim() !== "")
                .map((line, index) => (
                  <p key={index} className="mb-2">
                    {line}
                  </p>
                ))}
            </div>
          </div>
        )}
      </div>

      <Lightbox
        open={openLightbox}
        close={() => setOpenLightbox(false)}
        slides={images}
        plugins={[Zoom]}
      />
    </div>
  );
};

export default ProductDetail;
